// extracted by mini-css-extract-plugin
module.exports = {"speech":"flashMessage_speech__1g1lS","alert":"flashMessage_alert__981mM","success":"flashMessage_success__MX_3m"};